export var VariableRwType;
(function (VariableRwType) {
    VariableRwType[VariableRwType["Write"] = 2] = "Write";
    VariableRwType[VariableRwType["Read"] = 4] = "Read";
    VariableRwType[VariableRwType["ReadWrite"] = 6] = "ReadWrite";
})(VariableRwType || (VariableRwType = {}));
